module.exports = __webpack_public_path__ + "img/my-type-2.9f7644bb.png";